import React from 'react';
import IconList from '../../../../../../../../common/component/IconList';

const AddonBenefits = ({ section }) => (
  <div className="addon-benefits">
    <IconList section={section} />
  </div>
);

export default AddonBenefits;
